onComplete(function () {
	// Add code here.
	const isMobile = window.matchMedia("(max-width: 768px)").matches;
	const PAGE_SCROLL_THRESHOLD = isMobile ? 50 : 100;

	window.addEventListener('scroll', () => {
		const scroll = window.pageYOffset || document.documentElement.scrollTop;
		const navHeader = document.querySelectorAll('.nav-header');
		if (scroll >= PAGE_SCROLL_THRESHOLD) {
			navHeader.forEach(el => el.classList.add('scroll'));
		} else {
			navHeader.forEach(el => el.classList.remove('scroll'));
		}
	})
});